import { getApiUrl, API_URL } from '@/utils/api';
import ApiBase from './ApiBase';

export default class BoxService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.USER, '/box');

  get(storeId: string, storeIdForPriceCookie = null) {
    let options = {
      credentials: 'include'
    } as any;

    if (storeIdForPriceCookie) {
      options = { ...options, cookies: `storeIdForPrice=${storeIdForPriceCookie};` };
    }
    return this.api.getJSON(`${BoxService.baseUrl}/${storeId}`, options);
  }

  addProduct(storeId: string, partnumber: string, qty: number) {
    return this.api.postJSON(`${BoxService.baseUrl}/${storeId}/product`, {
      partnumber,
      qty
    }, {
      credentials: 'include',
      guestToken: true
    });
  }

  addProducts(storeId: string, itemsList) {
    return this.api.postJSON(`${BoxService.baseUrl}/${storeId}/products`, itemsList, {
      credentials: 'include',
      guestToken: true
    });
  }

  changeCustomization(storeId: string, boxId: string, customization, customizationQt: number) {
    return this.api.postJSON(`${BoxService.baseUrl}/${storeId}/customization`, {
      boxId,
      customization,
      customizationQt
    });
  }

  updateCustomizationAttribute(storeId: string, boxId: string, attributeName: string, newValue: any) {
    return this.api.postJSON(`${BoxService.baseUrl}/${storeId}/customization/update`, {
      boxId,
      attributeForUpdate: {
        attributeName,
        newValue
      }
    });
  }

  delete(storeId: string, wineboxId: string) {
    return this.api.deleteJSON(`${BoxService.baseUrl}/${storeId}`, wineboxId);
  }
}
